// return a list of country - country code pairs

export function countries(filter = false) {
  let locale = sessionStorage.getItem('locale') || 'en';
  let countryList = [];
  let blockList = ['CU', 'IR', 'KP', 'RU', 'UA', 'SY', 'SD', 'AF', 'BY', 'MM', 'IL', 'VE', 'PS'];

  if (locale == 'fr') {
    countryList = [
      {
        text: 'Aruba',
        value: 'AW'
      },
      {
        text: 'Afghanistan',
        value: 'AF'
      },
      {
        text: 'Angola',
        value: 'AO'
      },
      {
        text: 'Anguilla',
        value: 'AI'
      },
      {
        text: 'Ahvenanmaa',
        value: 'AX'
      },
      {
        text: 'Albanie',
        value: 'AL'
      },
      {
        text: 'Andorre',
        value: 'AD'
      },
      {
        text: 'Émirats arabes unis',
        value: 'AE'
      },
      {
        text: 'Argentine',
        value: 'AR'
      },
      {
        text: 'Arménie',
        value: 'AM'
      },
      {
        text: 'Samoa américaines',
        value: 'AS'
      },
      {
        text: 'Antarctique',
        value: 'AQ'
      },
      {
        text: 'Terres australes et antarctiques françaises',
        value: 'TF'
      },
      {
        text: 'Antigua-et-Barbuda',
        value: 'AG'
      },
      {
        text: 'Australie',
        value: 'AU'
      },
      {
        text: 'Autriche',
        value: 'AT'
      },
      {
        text: 'Azerbaïdjan',
        value: 'AZ'
      },
      {
        text: 'Burundi',
        value: 'BI'
      },
      {
        text: 'Belgique',
        value: 'BE'
      },
      {
        text: 'Bénin',
        value: 'BJ'
      },
      {
        text: 'Burkina Faso',
        value: 'BF'
      },
      {
        text: 'Bangladesh',
        value: 'BD'
      },
      {
        text: 'Bulgarie',
        value: 'BG'
      },
      {
        text: 'Bahreïn',
        value: 'BH'
      },
      {
        text: 'Bahamas',
        value: 'BS'
      },
      {
        text: 'Bosnie-Herzégovine',
        value: 'BA'
      },
      {
        text: 'Saint-Barthélemy',
        value: 'BL'
      },
      {
        text: 'Biélorussie',
        value: 'BY'
      },
      {
        text: 'Belize',
        value: 'BZ'
      },
      {
        text: 'Bermudes',
        value: 'BM'
      },
      {
        text: 'Bolivie',
        value: 'BO'
      },
      {
        text: 'Brésil',
        value: 'BR'
      },
      {
        text: 'Barbade',
        value: 'BB'
      },
      {
        text: 'Brunei',
        value: 'BN'
      },
      {
        text: 'Bhoutan',
        value: 'BT'
      },
      {
        text: 'Île Bouvet',
        value: 'BV'
      },
      {
        text: 'Botswana',
        value: 'BW'
      },
      {
        text: 'République centrafricaine',
        value: 'CF'
      },
      {
        text: 'Canada',
        value: 'CA'
      },
      {
        text: 'Îles Cocos',
        value: 'CC'
      },
      {
        text: 'Suisse',
        value: 'CH'
      },
      {
        text: 'Chili',
        value: 'CL'
      },
      {
        text: 'Chine',
        value: 'CN'
      },
      {
        text: 'Côte d\'Ivoire',
        value: 'CI'
      },
      {
        text: 'Cameroun',
        value: 'CM'
      },
      {
        text: 'Congo (Rép. dém.)',
        value: 'CD'
      },
      {
        text: 'Congo',
        value: 'CG'
      },
      {
        text: 'Îles Cook',
        value: 'CK'
      },
      {
        text: 'Colombie',
        value: 'CO'
      },
      {
        text: 'Comores',
        value: 'KM'
      },
      {
        text: 'Îles du Cap-Vert',
        value: 'CV'
      },
      {
        text: 'Costa Rica',
        value: 'CR'
      },
      {
        text: 'Cuba',
        value: 'CU'
      },
      {
        text: 'Curaçao',
        value: 'CW'
      },
      {
        text: 'Île Christmas',
        value: 'CX'
      },
      {
        text: 'Îles Caïmans',
        value: 'KY'
      },
      {
        text: 'Chypre',
        value: 'CY'
      },
      {
        text: 'République tchèque',
        value: 'CZ'
      },
      {
        text: 'Allemagne',
        value: 'DE'
      },
      {
        text: 'Djibouti',
        value: 'DJ'
      },
      {
        text: 'Dominique',
        value: 'DM'
      },
      {
        text: 'Danemark',
        value: 'DK'
      },
      {
        text: 'République dominicaine',
        value: 'DO'
      },
      {
        text: 'Algérie',
        value: 'DZ'
      },
      {
        text: 'Équateur',
        value: 'EC'
      },
      {
        text: 'Égypte',
        value: 'EG'
      },
      {
        text: 'Érythrée',
        value: 'ER'
      },
      {
        text: 'Sahara Occidental',
        value: 'EH'
      },
      {
        text: 'Espagne',
        value: 'ES'
      },
      {
        text: 'Estonie',
        value: 'EE'
      },
      {
        text: 'Éthiopie',
        value: 'ET'
      },
      {
        text: 'Finlande',
        value: 'FI'
      },
      {
        text: 'Fidji',
        value: 'FJ'
      },
      {
        text: 'Îles Malouines',
        value: 'FK'
      },
      {
        text: 'France',
        value: 'FR'
      },
      {
        text: 'Îles Féroé',
        value: 'FO'
      },
      {
        text: 'Micronésie',
        value: 'FM'
      },
      {
        text: 'Gabon',
        value: 'GA'
      },
      {
        text: 'Royaume-Uni',
        value: 'GB'
      },
      {
        text: 'Géorgie',
        value: 'GE'
      },
      {
        text: 'Guernesey',
        value: 'GG'
      },
      {
        text: 'Ghana',
        value: 'GH'
      },
      {
        text: 'Gibraltar',
        value: 'GI'
      },
      {
        text: 'Guinée',
        value: 'GN'
      },
      {
        text: 'Guadeloupe',
        value: 'GP'
      },
      {
        text: 'Gambie',
        value: 'GM'
      },
      {
        text: 'Guinée-Bissau',
        value: 'GW'
      },
      {
        text: 'Guinée équatoriale',
        value: 'GQ'
      },
      {
        text: 'Grèce',
        value: 'GR'
      },
      {
        text: 'Grenade',
        value: 'GD'
      },
      {
        text: 'Groenland',
        value: 'GL'
      },
      {
        text: 'Guatemala',
        value: 'GT'
      },
      {
        text: 'Guyane',
        value: 'GF'
      },
      {
        text: 'Guam',
        value: 'GU'
      },
      {
        text: 'Guyana',
        value: 'GY'
      },
      {
        text: 'Hong Kong',
        value: 'HK'
      },
      {
        text: 'Îles Heard-et-MacDonald',
        value: 'HM'
      },
      {
        text: 'Honduras',
        value: 'HN'
      },
      {
        text: 'Croatie',
        value: 'HR'
      },
      {
        text: 'Haïti',
        value: 'HT'
      },
      {
        text: 'Hongrie',
        value: 'HU'
      },
      {
        text: 'Indonésie',
        value: 'ID'
      },
      {
        text: 'Île de Man',
        value: 'IM'
      },
      {
        text: 'Inde',
        value: 'IN'
      },
      {
        text: 'Territoire britannique de l\'océan Indien',
        value: 'IO'
      },
      {
        text: 'Irlande',
        value: 'IE'
      },
      {
        text: 'Iran',
        value: 'IR'
      },
      {
        text: 'Irak',
        value: 'IQ'
      },
      {
        text: 'Islande',
        value: 'IS'
      },
      {
        text: 'Israël',
        value: 'IL'
      },
      {
        text: 'Italie',
        value: 'IT'
      },
      {
        text: 'Jamaïque',
        value: 'JM'
      },
      {
        text: 'Jersey',
        value: 'JE'
      },
      {
        text: 'Jordanie',
        value: 'JO'
      },
      {
        text: 'Japon',
        value: 'JP'
      },
      {
        text: 'Kazakhstan',
        value: 'KZ'
      },
      {
        text: 'Kenya',
        value: 'KE'
      },
      {
        text: 'Kirghizistan',
        value: 'KG'
      },
      {
        text: 'Cambodge',
        value: 'KH'
      },
      {
        text: 'Kiribati',
        value: 'KI'
      },
      {
        text: 'Saint-Christophe-et-Niévès',
        value: 'KN'
      },
      {
        text: 'Corée du Sud',
        value: 'KR'
      },
      {
        text: 'Kosovo',
        value: 'XK'
      },
      {
        text: 'Koweït',
        value: 'KW'
      },
      {
        text: 'Laos',
        value: 'LA'
      },
      {
        text: 'Liban',
        value: 'LB'
      },
      {
        text: 'Liberia',
        value: 'LR'
      },
      {
        text: 'Libye',
        value: 'LY'
      },
      {
        text: 'Sainte-Lucie',
        value: 'LC'
      },
      {
        text: 'Liechtenstein',
        value: 'LI'
      },
      {
        text: 'Sri Lanka',
        value: 'LK'
      },
      {
        text: 'Lesotho',
        value: 'LS'
      },
      {
        text: 'Lituanie',
        value: 'LT'
      },
      {
        text: 'Luxembourg',
        value: 'LU'
      },
      {
        text: 'Lettonie',
        value: 'LV'
      },
      {
        text: 'Macao',
        value: 'MO'
      },
      {
        text: 'Saint-Martin',
        value: 'SX'
      },
      {
        text: 'Maroc',
        value: 'MA'
      },
      {
        text: 'Monaco',
        value: 'MC'
      },
      {
        text: 'Moldavie',
        value: 'MD'
      },
      {
        text: 'Madagascar',
        value: 'MG'
      },
      {
        text: 'Maldives',
        value: 'MV'
      },
      {
        text: 'Mexique',
        value: 'MX'
      },
      {
        text: 'Îles Marshall',
        value: 'MH'
      },
      {
        text: 'Macédoine',
        value: 'MK'
      },
      {
        text: 'Mali',
        value: 'ML'
      },
      {
        text: 'Malte',
        value: 'MT'
      },
      {
        text: 'Birmanie',
        value: 'MM'
      },
      {
        text: 'Monténégro',
        value: 'ME'
      },
      {
        text: 'Mongolie',
        value: 'MN'
      },
      {
        text: 'Îles Mariannes du Nord',
        value: 'MP'
      },
      {
        text: 'Mozambique',
        value: 'MZ'
      },
      {
        text: 'Mauritanie',
        value: 'MR'
      },
      {
        text: 'Montserrat',
        value: 'MS'
      },
      {
        text: 'Martinique',
        value: 'MQ'
      },
      {
        text: 'Île Maurice',
        value: 'MU'
      },
      {
        text: 'Malawi',
        value: 'MW'
      },
      {
        text: 'Malaisie',
        value: 'MY'
      },
      {
        text: 'Mayotte',
        value: 'YT'
      },
      {
        text: 'Namibie',
        value: 'NA'
      },
      {
        text: 'Nouvelle-Calédonie',
        value: 'NC'
      },
      {
        text: 'Niger',
        value: 'NE'
      },
      {
        text: 'Île Norfolk',
        value: 'NF'
      },
      {
        text: 'Nigéria',
        value: 'NG'
      },
      {
        text: 'Nicaragua',
        value: 'NI'
      },
      {
        text: 'Niue',
        value: 'NU'
      },
      {
        text: 'Pays-Bas',
        value: 'NL'
      },
      {
        text: 'Norvège',
        value: 'NO'
      },
      {
        text: 'Népal',
        value: 'NP'
      },
      {
        text: 'Nauru',
        value: 'NR'
      },
      {
        text: 'Nouvelle-Zélande',
        value: 'NZ'
      },
      {
        text: 'Oman',
        value: 'OM'
      },
      {
        text: 'Pakistan',
        value: 'PK'
      },
      {
        text: 'Panama',
        value: 'PA'
      },
      {
        text: 'Îles Pitcairn',
        value: 'PN'
      },
      {
        text: 'Pérou',
        value: 'PE'
      },
      {
        text: 'Philippines',
        value: 'PH'
      },
      {
        text: 'Palaos (Palau)',
        value: 'PW'
      },
      {
        text: 'Papouasie-Nouvelle-Guinée',
        value: 'PG'
      },
      {
        text: 'Pologne',
        value: 'PL'
      },
      {
        text: 'Porto Rico',
        value: 'PR'
      },
      {
        text: 'Corée du Nord',
        value: 'KP'
      },
      {
        text: 'Portugal',
        value: 'PT'
      },
      {
        text: 'Paraguay',
        value: 'PY'
      },
      {
        text: 'Palestine',
        value: 'PS'
      },
      {
        text: 'Polynésie française',
        value: 'PF'
      },
      {
        text: 'Qatar',
        value: 'QA'
      },
      {
        text: 'Réunion',
        value: 'RE'
      },
      {
        text: 'Roumanie',
        value: 'RO'
      },
      {
        text: 'Russie',
        value: 'RU'
      },
      {
        text: 'Rwanda',
        value: 'RW'
      },
      {
        text: 'Arabie Saoudite',
        value: 'SA'
      },
      {
        text: 'Soudan',
        value: 'SD'
      },
      {
        text: 'Sénégal',
        value: 'SN'
      },
      {
        text: 'Singapour',
        value: 'SG'
      },
      {
        text: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
        value: 'GS'
      },
      {
        text: 'Svalbard et Jan Mayen',
        value: 'SJ'
      },
      {
        text: 'Îles Salomon',
        value: 'SB'
      },
      {
        text: 'Sierra Leone',
        value: 'SL'
      },
      {
        text: 'Salvador',
        value: 'SV'
      },
      {
        text: 'Saint-Marin',
        value: 'SM'
      },
      {
        text: 'Somalie',
        value: 'SO'
      },
      {
        text: 'Saint-Pierre-et-Miquelon',
        value: 'PM'
      },
      {
        text: 'Serbie',
        value: 'RS'
      },
      {
        text: 'Soudan du Sud',
        value: 'SS'
      },
      {
        text: 'São Tomé et Príncipe',
        value: 'ST'
      },
      {
        text: 'Surinam',
        value: 'SR'
      },
      {
        text: 'Slovaquie',
        value: 'SK'
      },
      {
        text: 'Slovénie',
        value: 'SI'
      },
      {
        text: 'Suède',
        value: 'SE'
      },
      {
        text: 'Swaziland',
        value: 'SZ'
      },
      {
        text: 'Seychelles',
        value: 'SC'
      },
      {
        text: 'Syrie',
        value: 'SY'
      },
      {
        text: 'Îles Turques-et-Caïques',
        value: 'TC'
      },
      {
        text: 'Tchad',
        value: 'TD'
      },
      {
        text: 'Togo',
        value: 'TG'
      },
      {
        text: 'Thaïlande',
        value: 'TH'
      },
      {
        text: 'Tadjikistan',
        value: 'TJ'
      },
      {
        text: 'Tokelau',
        value: 'TK'
      },
      {
        text: 'Turkménistan',
        value: 'TM'
      },
      {
        text: 'Timor oriental',
        value: 'TL'
      },
      {
        text: 'Tonga',
        value: 'TO'
      },
      {
        text: 'Trinité-et-Tobago',
        value: 'TT'
      },
      {
        text: 'Tunisie',
        value: 'TN'
      },
      {
        text: 'Turquie',
        value: 'TR'
      },
      {
        text: 'Tuvalu',
        value: 'TV'
      },
      {
        text: 'Taïwan',
        value: 'TW'
      },
      {
        text: 'Tanzanie',
        value: 'TZ'
      },
      {
        text: 'Ouganda',
        value: 'UG'
      },
      {
        text: 'Ukraine',
        value: 'UA'
      },
      {
        text: 'Îles mineures éloignées des États-Unis',
        value: 'UM'
      },
      {
        text: 'Uruguay',
        value: 'UY'
      },
      {
        text: 'États-Unis',
        value: 'US'
      },
      {
        text: 'Ouzbékistan',
        value: 'UZ'
      },
      {
        text: 'Cité du Vatican',
        value: 'VA'
      },
      {
        text: 'Saint-Vincent-et-les-Grenadines',
        value: 'VC'
      },
      {
        text: 'Venezuela',
        value: 'VE'
      },
      {
        text: 'Îles Vierges britanniques',
        value: 'VG'
      },
      {
        text: 'Îles Vierges des États-Unis',
        value: 'VI'
      },
      {
        text: 'Viêt Nam',
        value: 'VN'
      },
      {
        text: 'Vanuatu',
        value: 'VU'
      },
      {
        text: 'Wallis-et-Futuna',
        value: 'WF'
      },
      {
        text: 'Samoa',
        value: 'WS'
      },
      {
        text: 'Yémen',
        value: 'YE'
      },
      {
        text: 'Afrique du Sud',
        value: 'ZA'
      },
      {
        text: 'Zambie',
        value: 'ZM'
      },
      {
        text: 'Zimbabwe',
        value: 'ZW'
      },
      {
        text: 'Bonaire, Saint-Eustache et Saba',
        value: 'BQ'
      },
      {
        text: 'Sainte-Hélène',
        value: 'SH'
      },
      {
        text: 'Mondial',
        value: 'WW'
      }
    ];
  } else {
    countryList = [
      {
        text: 'Afghanistan',
        value: 'AF'
      },
      {
        text: 'Åland Islands',
        value: 'AX'
      },
      {
        text: 'Albania',
        value: 'AL'
      },
      {
        text: 'Algeria',
        value: 'DZ'
      },
      {
        text: 'American Samoa',
        value: 'AS'
      },
      {
        text: 'Andorra',
        value: 'AD'
      },
      {
        text: 'Angola',
        value: 'AO'
      },
      {
        text: 'Anguilla',
        value: 'AI'
      },
      {
        text: 'Antarctica',
        value: 'AQ'
      },
      {
        text: 'Antigua and Barbuda',
        value: 'AG'
      },
      {
        text: 'Argentina',
        value: 'AR'
      },
      {
        text: 'Armenia',
        value: 'AM'
      },
      {
        text: 'Aruba',
        value: 'AW'
      },
      {
        text: 'Australia',
        value: 'AU'
      },
      {
        text: 'Austria',
        value: 'AT'
      },
      {
        text: 'Azerbaijan',
        value: 'AZ'
      },
      {
        text: 'Bahamas',
        value: 'BS'
      },
      {
        text: 'Bahrain',
        value: 'BH'
      },
      {
        text: 'Bangladesh',
        value: 'BD'
      },
      {
        text: 'Barbados',
        value: 'BB'
      },
      {
        text: 'Belarus',
        value: 'BY'
      },
      {
        text: 'Belgium',
        value: 'BE'
      },
      {
        text: 'Belize',
        value: 'BZ'
      },
      {
        text: 'Benin',
        value: 'BJ'
      },
      {
        text: 'Bermuda',
        value: 'BM'
      },
      {
        text: 'Bhutan',
        value: 'BT'
      },
      {
        text: 'Bolivia',
        value: 'BO'
      },
      {
        text: 'Bonaire, Sint Eustatius and Saba',
        value: 'BQ'
      },
      {
        text: 'Bosnia and Herzegovina',
        value: 'BA'
      },
      {
        text: 'Botswana',
        value: 'BW'
      },
      {
        text: 'Bouvet Island',
        value: 'BV'
      },
      {
        text: 'Brazil',
        value: 'BR'
      },
      {
        text: 'British Indian Ocean Territory',
        value: 'IO'
      },
      {
        text: 'British Virgin Islands',
        value: 'VG'
      },
      {
        text: 'Brunei',
        value: 'BN'
      },
      {
        text: 'Bulgaria',
        value: 'BG'
      },
      {
        text: 'Burkina Faso',
        value: 'BF'
      },
      {
        text: 'Burundi',
        value: 'BI'
      },
      {
        text: 'Cambodia',
        value: 'KH'
      },
      {
        text: 'Cameroon',
        value: 'CM'
      },
      {
        text: 'Canada',
        value: 'CA'
      },
      {
        text: 'Cape Verde',
        value: 'CV'
      },
      {
        text: 'Cayman Islands',
        value: 'KY'
      },
      {
        text: 'Central African Republic',
        value: 'CF'
      },
      {
        text: 'Chad',
        value: 'TD'
      },
      {
        text: 'Chile',
        value: 'CL'
      },
      {
        text: 'China',
        value: 'CN'
      },
      {
        text: 'Christmas Island',
        value: 'CX'
      },
      {
        text: 'Cocos (Keeling) Islands',
        value: 'CC'
      },
      {
        text: 'Colombia',
        value: 'CO'
      },
      {
        text: 'Comoros',
        value: 'KM'
      },
      {
        text: 'Cook Islands',
        value: 'CK'
      },
      {
        text: 'Costa Rica',
        value: 'CR'
      },
      {
        text: 'Croatia',
        value: 'HR'
      },
      {
        text: 'Cuba',
        value: 'CU'
      },
      {
        text: 'Curaçao',
        value: 'CW'
      },
      {
        text: 'Cyprus',
        value: 'CY'
      },
      {
        text: 'Czech Republic',
        value: 'CZ'
      },
      {
        text: 'Denmark',
        value: 'DK'
      },
      {
        text: 'Djibouti',
        value: 'DJ'
      },
      {
        text: 'Dominica',
        value: 'DM'
      },
      {
        text: 'Dominican Republic',
        value: 'DO'
      },
      {
        text: 'DR Congo',
        value: 'CD'
      },
      {
        text: 'Ecuador',
        value: 'EC'
      },
      {
        text: 'Egypt',
        value: 'EG'
      },
      {
        text: 'El Salvador',
        value: 'SV'
      },
      {
        text: 'Equatorial Guinea',
        value: 'GQ'
      },
      {
        text: 'Eritrea',
        value: 'ER'
      },
      {
        text: 'Estonia',
        value: 'EE'
      },
      {
        text: 'Ethiopia',
        value: 'ET'
      },
      {
        text: 'Falkland Islands',
        value: 'FK'
      },
      {
        text: 'Faroe Islands',
        value: 'FO'
      },
      {
        text: 'Fiji',
        value: 'FJ'
      },
      {
        text: 'Finland',
        value: 'FI'
      },
      {
        text: 'France',
        value: 'FR'
      },
      {
        text: 'French Guiana',
        value: 'GF'
      },
      {
        text: 'French Polynesia',
        value: 'PF'
      },
      {
        text: 'French Southern and Antarctic Lands',
        value: 'TF'
      },
      {
        text: 'Gabon',
        value: 'GA'
      },
      {
        text: 'Gambia',
        value: 'GM'
      },
      {
        text: 'Georgia',
        value: 'GE'
      },
      {
        text: 'Germany',
        value: 'DE'
      },
      {
        text: 'Ghana',
        value: 'GH'
      },
      {
        text: 'Gibraltar',
        value: 'GI'
      },
      {
        text: 'Greece',
        value: 'GR'
      },
      {
        text: 'Greenland',
        value: 'GL'
      },
      {
        text: 'Grenada',
        value: 'GD'
      },
      {
        text: 'Guadeloupe',
        value: 'GP'
      },
      {
        text: 'Guam',
        value: 'GU'
      },
      {
        text: 'Guatemala',
        value: 'GT'
      },
      {
        text: 'Guernsey',
        value: 'GG'
      },
      {
        text: 'Guinea',
        value: 'GN'
      },
      {
        text: 'Guinea-Bissau',
        value: 'GW'
      },
      {
        text: 'Guyana',
        value: 'GY'
      },
      {
        text: 'Haiti',
        value: 'HT'
      },
      {
        text: 'Heard Island and McDonald Islands',
        value: 'HM'
      },
      {
        text: 'Honduras',
        value: 'HN'
      },
      {
        text: 'Hong Kong',
        value: 'HK'
      },
      {
        text: 'Hungary',
        value: 'HU'
      },
      {
        text: 'Iceland',
        value: 'IS'
      },
      {
        text: 'India',
        value: 'IN'
      },
      {
        text: 'Indonesia',
        value: 'ID'
      },
      {
        text: 'Iran',
        value: 'IR'
      },
      {
        text: 'Iraq',
        value: 'IQ'
      },
      {
        text: 'Ireland',
        value: 'IE'
      },
      {
        text: 'Isle of Man',
        value: 'IM'
      },
      {
        text: 'Israel',
        value: 'IL'
      },
      {
        text: 'Italy',
        value: 'IT'
      },
      {
        text: 'Ivory Coast',
        value: 'CI'
      },
      {
        text: 'Jamaica',
        value: 'JM'
      },
      {
        text: 'Japan',
        value: 'JP'
      },
      {
        text: 'Jersey',
        value: 'JE'
      },
      {
        text: 'Jordan',
        value: 'JO'
      },
      {
        text: 'Kazakhstan',
        value: 'KZ'
      },
      {
        text: 'Kenya',
        value: 'KE'
      },
      {
        text: 'Kiribati',
        value: 'KI'
      },
      {
        text: 'Kosovo',
        value: 'XK'
      },
      {
        text: 'Kuwait',
        value: 'KW'
      },
      {
        text: 'Kyrgyzstan',
        value: 'KG'
      },
      {
        text: 'Laos',
        value: 'LA'
      },
      {
        text: 'Latvia',
        value: 'LV'
      },
      {
        text: 'Lebanon',
        value: 'LB'
      },
      {
        text: 'Lesotho',
        value: 'LS'
      },
      {
        text: 'Liberia',
        value: 'LR'
      },
      {
        text: 'Libya',
        value: 'LY'
      },
      {
        text: 'Liechtenstein',
        value: 'LI'
      },
      {
        text: 'Lithuania',
        value: 'LT'
      },
      {
        text: 'Luxembourg',
        value: 'LU'
      },
      {
        text: 'Macau',
        value: 'MO'
      },
      {
        text: 'Macedonia',
        value: 'MK'
      },
      {
        text: 'Madagascar',
        value: 'MG'
      },
      {
        text: 'Malawi',
        value: 'MW'
      },
      {
        text: 'Malaysia',
        value: 'MY'
      },
      {
        text: 'Maldives',
        value: 'MV'
      },
      {
        text: 'Mali',
        value: 'ML'
      },
      {
        text: 'Malta',
        value: 'MT'
      },
      {
        text: 'Marshall Islands',
        value: 'MH'
      },
      {
        text: 'Martinique',
        value: 'MQ'
      },
      {
        text: 'Mauritania',
        value: 'MR'
      },
      {
        text: 'Mauritius',
        value: 'MU'
      },
      {
        text: 'Mayotte',
        value: 'YT'
      },
      {
        text: 'Mexico',
        value: 'MX'
      },
      {
        text: 'Micronesia',
        value: 'FM'
      },
      {
        text: 'Moldova',
        value: 'MD'
      },
      {
        text: 'Monaco',
        value: 'MC'
      },
      {
        text: 'Mongolia',
        value: 'MN'
      },
      {
        text: 'Montenegro',
        value: 'ME'
      },
      {
        text: 'Montserrat',
        value: 'MS'
      },
      {
        text: 'Morocco',
        value: 'MA'
      },
      {
        text: 'Mozambique',
        value: 'MZ'
      },
      {
        text: 'Myanmar',
        value: 'MM'
      },
      {
        text: 'Namibia',
        value: 'NA'
      },
      {
        text: 'Nauru',
        value: 'NR'
      },
      {
        text: 'Nepal',
        value: 'NP'
      },
      {
        text: 'Netherlands',
        value: 'NL'
      },
      {
        text: 'New Caledonia',
        value: 'NC'
      },
      {
        text: 'New Zealand',
        value: 'NZ'
      },
      {
        text: 'Nicaragua',
        value: 'NI'
      },
      {
        text: 'Niger',
        value: 'NE'
      },
      {
        text: 'Nigeria',
        value: 'NG'
      },
      {
        text: 'Niue',
        value: 'NU'
      },
      {
        text: 'Norfolk Island',
        value: 'NF'
      },
      {
        text: 'Northern Mariana Islands',
        value: 'MP'
      },
      {
        text: 'North Korea',
        value: 'KP'
      },
      {
        text: 'Norway',
        value: 'NO'
      },
      {
        text: 'Oman',
        value: 'OM'
      },
      {
        text: 'Pakistan',
        value: 'PK'
      },
      {
        text: 'Palau',
        value: 'PW'
      },
      {
        text: 'Palestine',
        value: 'PS'
      },
      {
        text: 'Panama',
        value: 'PA'
      },
      {
        text: 'Papua New Guinea',
        value: 'PG'
      },
      {
        text: 'Paraguay',
        value: 'PY'
      },
      {
        text: 'Peru',
        value: 'PE'
      },
      {
        text: 'Philippines',
        value: 'PH'
      },
      {
        text: 'Pitcairn Islands',
        value: 'PN'
      },
      {
        text: 'Poland',
        value: 'PL'
      },
      {
        text: 'Portugal',
        value: 'PT'
      },
      {
        text: 'Puerto Rico',
        value: 'PR'
      },
      {
        text: 'Qatar',
        value: 'QA'
      },
      {
        text: 'Republic of the Congo',
        value: 'CG'
      },
      {
        text: 'Réunion',
        value: 'RE'
      },
      {
        text: 'Romania',
        value: 'RO'
      },
      {
        text: 'Russia',
        value: 'RU'
      },
      {
        text: 'Rwanda',
        value: 'RW'
      },
      {
        text: 'Saint Barthélemy',
        value: 'BL'
      },
      {
        text: 'Saint Helena',
        value: 'SH'
      },
      {
        text: 'Saint Kitts and Nevis',
        value: 'KN'
      },
      {
        text: 'Saint Lucia',
        value: 'LC'
      },
      {
        text: 'Saint Martin',
        value: 'MF'
      },
      {
        text: 'Saint Pierre and Miquelon',
        value: 'PM'
      },
      {
        text: 'Saint Vincent and the Grenadines',
        value: 'VC'
      },
      {
        text: 'Samoa',
        value: 'WS'
      },
      {
        text: 'San Marino',
        value: 'SM'
      },
      {
        text: 'São Tomé and Príncipe',
        value: 'ST'
      },
      {
        text: 'Saudi Arabia',
        value: 'SA'
      },
      {
        text: 'Senegal',
        value: 'SN'
      },
      {
        text: 'Serbia',
        value: 'RS'
      },
      {
        text: 'Seychelles',
        value: 'SC'
      },
      {
        text: 'Sierra Leone',
        value: 'SL'
      },
      {
        text: 'Singapore',
        value: 'SG'
      },
      {
        text: 'Sint Maarten',
        value: 'SX'
      },
      {
        text: 'Slovakia',
        value: 'SK'
      },
      {
        text: 'Slovenia',
        value: 'SI'
      },
      {
        text: 'Solomon Islands',
        value: 'SB'
      },
      {
        text: 'Somalia',
        value: 'SO'
      },
      {
        text: 'South Africa',
        value: 'ZA'
      },
      {
        text: 'South Georgia',
        value: 'GS'
      },
      {
        text: 'South Korea',
        value: 'KR'
      },
      {
        text: 'South Sudan',
        value: 'SS'
      },
      {
        text: 'Spain',
        value: 'ES'
      },
      {
        text: 'Sri Lanka',
        value: 'LK'
      },
      {
        text: 'Sudan',
        value: 'SD'
      },
      {
        text: 'Suriname',
        value: 'SR'
      },
      {
        text: 'Svalbard and Jan Mayen',
        value: 'SJ'
      },
      {
        text: 'Swaziland',
        value: 'SZ'
      },
      {
        text: 'Sweden',
        value: 'SE'
      },
      {
        text: 'Switzerland',
        value: 'CH'
      },
      {
        text: 'Syria',
        value: 'SY'
      },
      {
        text: 'Taiwan',
        value: 'TW'
      },
      {
        text: 'Tajikistan',
        value: 'TJ'
      },
      {
        text: 'Tanzania',
        value: 'TZ'
      },
      {
        text: 'Thailand',
        value: 'TH'
      },
      {
        text: 'Timor-Leste',
        value: 'TL'
      },
      {
        text: 'Togo',
        value: 'TG'
      },
      {
        text: 'Tokelau',
        value: 'TK'
      },
      {
        text: 'Tonga',
        value: 'TO'
      },
      {
        text: 'Trinidad and Tobago',
        value: 'TT'
      },
      {
        text: 'Tunisia',
        value: 'TN'
      },
      {
        text: 'Turkey',
        value: 'TR'
      },
      {
        text: 'Turkmenistan',
        value: 'TM'
      },
      {
        text: 'Turks and Caicos Islands',
        value: 'TC'
      },
      {
        text: 'Tuvalu',
        value: 'TV'
      },
      {
        text: 'Uganda',
        value: 'UG'
      },
      {
        text: 'Ukraine',
        value: 'UA'
      },
      {
        text: 'United Arab Emirates',
        value: 'AE'
      },
      {
        text: 'United Kingdom',
        value: 'GB'
      },
      {
        text: 'United States',
        value: 'US'
      },
      {
        text: 'United States Minor Outlying Islands',
        value: 'UM'
      },
      {
        text: 'United States Virgin Islands',
        value: 'VI'
      },
      {
        text: 'Uruguay',
        value: 'UY'
      },
      {
        text: 'Uzbekistan',
        value: 'UZ'
      },
      {
        text: 'Vanuatu',
        value: 'VU'
      },
      {
        text: 'Vatican City',
        value: 'VA'
      },
      {
        text: 'Venezuela',
        value: 'VE'
      },
      {
        text: 'Vietnam',
        value: 'VN'
      },
      {
        text: 'Wallis and Futuna',
        value: 'WF'
      },
      {
        text: 'Western Sahara',
        value: 'EH'
      },
      {
        text: 'Yemen',
        value: 'YE'
      },
      {
        text: 'Zambia',
        value: 'ZM'
      },
      {
        text: 'Zimbabwe',
        value: 'ZW'
      },
      {
        text: 'Worldwide',
        value: 'WW'
      }
    ];  
  }
  
  return filter ? countryList.filter((country) => !blockList.includes(country.value)) : countryList;
}

export function getAllCountries() {
  let countryList = countries();
  return Object.fromEntries(countryList.map(item => [item.value, item.text]));
}



// WEBPACK FOOTER //
// ./src/helpers/countries.js